import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["sourceId", "productLine", "use", "ctaKey", "nonMerchandiseIdProduct", "size", "trackingSource"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { SIGNUP } from 'pricing-pages-lib/constants/CtaTypes';
import { getHubsSignupCTA, getHubsSignupUrl, getPublicSiteDomain } from 'pricing-pages-lib/utils/publicPageUrls';
import { Metrics } from 'pricing-pages-ui/utils/metrics';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { CMS, MARKETING, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import { Flow } from 'signup-constants/Flow';
import { useAppSelector } from '../../reducers';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { getEligiblePublicTreatmentsSelector } from '../../selectors/ExperimentSelectors';
import { isUngatedForSeatsSelector } from '../../selectors/GatingSelectors';
import { trackSignupButtonClick } from '../../v2/utils/tracking/trackingEventUtils';
import { generateSignupUrlWithQueryParams } from '../../utils/urls/generateSignupUrl';
import { jsx as _jsx } from "react/jsx-runtime";
const ELIGIBLE_PRODUCT_LINES_TO_SIGNUP = {
  [MARKETING]: Flow.Marketing,
  [SALES]: Flow.Sales,
  [SERVICE]: Flow.Service,
  [CMS]: Flow.CmsFree,
  [COMMERCE]: Flow.Commerce,
  crm: Flow.Crm
};
const trackClick = (sourceId, signupType, ctaKey, trackingSource) => {
  trackSignupButtonClick({
    trackingSource,
    sourceId,
    signupType,
    value: ctaKey
  });
  Metrics.counter('signup-clicked').increment();
};
const SignupButton = _ref => {
  let {
      sourceId,
      productLine,
      use = 'primary',
      ctaKey = 'pricingPage.signupCtas.getStartedFree',
      nonMerchandiseIdProduct,
      size,
      trackingSource
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const hubsSignupUrl = getHubsSignupUrl({});
  const isUngatedForSeats = useAppSelector(isUngatedForSeatsSelector);
  const eligibleTreatments = useAppSelector(getEligiblePublicTreatmentsSelector);
  const signupType = productLine && Object.keys(ELIGIBLE_PRODUCT_LINES_TO_SIGNUP).includes(productLine) ? ELIGIBLE_PRODUCT_LINES_TO_SIGNUP[productLine] : Flow.Crm;
  const hubsSignupCta = getHubsSignupCTA({
    pathname: window.location.pathname,
    ctaType: SIGNUP,
    sourceId,
    productLine,
    nonMerchandiseIdProduct
  });
  const domain = getPublicSiteDomain();
  const domainWithoutHttps = domain.replace(/^https:\/\//, '');
  const HREF = generateSignupUrlWithQueryParams({
    signupType,
    queryParams: {
      hubsSignupCta,
      hubsSignupUrl,
      domainWithoutHttps,
      pathname: window.location.pathname,
      isUngatedForSeats,
      uuid: window.__utAnonId
    },
    experiments: eligibleTreatments
  });
  const isInApp = useAppSelector(isAppAuthSelector);
  return /*#__PURE__*/_jsx(Button, Object.assign({
    block: true,
    use: use,
    href: isInApp ? undefined : HREF,
    disabled: isInApp,
    onClick: () => trackClick(sourceId, signupType, ctaKey, trackingSource),
    "data-selenium-id": `sign-up-button-${productLine}`,
    size: size
  }, rest, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: ctaKey
    })
  }));
};
export default SignupButton;